// Copyright (c) 2020 Deere & Company

import DealerSettings from './components/dealer-settings';
import actionCreators from './action-creator/index';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../../sharedmodules/state/busy-counter';
import { withAuth } from '@okta/okta-react';

const mapStateToProps = (state) => ({
    userDealerMappedData: state.application.userSettings.dealerSettings,
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});

const mapDispatchToProps = (dispatch) => ({
    getUserDealerData: (auth, data) => dispatch(
        actionCreators.searchUserDealerMappedData(auth, data),
    ),
    resetUserDealerData: () => dispatch(actionCreators.resetUserDealerData()),
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(withAuth(DealerSettings));
